var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@polymer/paper-button/paper-button';
import '@polymer/paper-dialog/paper-dialog';
import { accountCircle, closeIcon } from './my-icons.js';
// This element is connected to the Redux store.
import { store } from '../store.js';
// These are the actions needed by this element.
import { firebaseSignOut } from '../actions/app.js';
// These are the shared styles needed by this element.
import { SharedStyles } from './shared-styles.js';
import { ButtonSharedStyles } from './button-shared-styles.js';
import { getAuth, sendPasswordResetEmail, signOut } from 'firebase/auth';
let MyAccount = class MyAccount extends LitElement {
    static get styles() {
        return [
            SharedStyles,
            ButtonSharedStyles,
            css `
        :host {
          display: block;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 99999;
          pointer-events: none;
        }

        .trigger-btn, paper-dialog {
          pointer-events: auto;
        }

        .trigger-btn {
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
          border-radius: 50%;
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          outline: none;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
          position: absolute;
          top: 13px;
          right: 15px;
          z-index: 99999;
        }

        .trigger-btn:hover {
          transform: scale(1.06);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .trigger-btn:active {
          transform: scale(0.96);
        }

        .trigger-img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid white;
        }

        .trigger-btn svg {
          width: 36px;
          height: 36px;
          fill: var(--app-primary-color, #1e88e5);
        }

        paper-dialog {
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2) !important;
          border: none;
          width: 310px;
          max-width: 90vw;
          background-color: white;
          margin: 0;
          padding: 0;
          top: 70px !important;
          right: 15px !important;
          left: auto !important;
          position: fixed !important;
        }

        .dialog-header {
          position: relative;
          background: linear-gradient(135deg, var(--app-primary-color, #1e88e5), #1565c0);
          color: white;
          padding: 16px;
          text-align: center;
          font-weight: 600;
          font-size: 1.1em;
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
          margin: 0 !important;
        }

        .close-btn {
          background: none;
          border: none;
          cursor: pointer;
          position: absolute;
          right: 12px;
          top: 12px;
          padding: 6px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.2s ease;
        }

        .close-btn:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }

        .close-btn svg {
          fill: white;
          width: 16px;
          height: 16px;
        }

        .dialog-body {
          padding: 20px 24px;
          margin: 0 !important;
        }

        .company-name {
          font-size: 1.25em;
          font-weight: 700;
          color: #202124;
          margin-bottom: 4px;
          text-align: center;
        }



        .profile-section {
          text-align: center;
          margin: 16px 0;
        }

        .profileImage {
          height: 72px;
          width: 72px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid white;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
          margin: 0 auto;
          display: block;
        }

        .initials-avatar {
          height: 66px;
          width: 66px;
          border-radius: 50%;
          background-color: var(--app-primary-color, #1e88e5);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: 700;
          margin: 0 auto;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
          border: 3px solid white;
        }

        .user-name {
          font-size: 1.15em;
          font-weight: 600;
          color: #202124;
          margin-top: 10px;
        }

        .roles-section {
          margin: 16px 0;
          text-align: center;
        }

        .roles-title {
          font-size: 0.75em;
          text-transform: uppercase;
          letter-spacing: 1.2px;
          color: #70757a;
          margin-bottom: 8px;
          font-weight: bold;
        }

        .roles-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 6px;
          max-height: 75px;
          overflow-y: auto;
          padding: 2px;
        }

        .role-tag {
          background-color: #f1f3f4;
          color: #3c4043;
          padding: 4px 10px;
          border-radius: 12px;
          font-size: 0.78em;
          font-weight: 500;
          border: 1px solid #e8eaed;
        }

        .actions-section {
          display: flex;
          flex-direction: column;
          gap: 8px;
          align-items: center;
          margin-top: 20px;
        }

        .logout-btn {
          background-color: var(--app-secondary-color, #ef5350);
          color: white !important;
          border-radius: 20px;
          padding: 8px 20px;
          font-size: 13px;
          text-transform: none;
          font-weight: 600;
          width: 100%;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          transition: all 0.2s ease;
          margin: 0 !important;
        }

        .logout-btn:hover {
          opacity: 0.95;
          box-shadow: 0 2px 8px rgba(239, 83, 80, 0.4);
        }

        .reset-btn {
          background-color: transparent;
          color: var(--app-primary-color, #1e88e5) !important;
          border-radius: 20px;
          padding: 8px 20px;
          font-size: 13px;
          text-transform: none;
          font-weight: 600;
          width: 100%;
          transition: all 0.2s ease;
          margin: 0 !important;
        }

        .reset-btn:hover {
          background-color: #f1f3f4;
          text-decoration: underline;
        }

        .install-prompt {
          margin-top: 8px;
          width: 100%;
        }

        .install-btn {
          background-color: #f1f3f4;
          color: #3c4043 !important;
          border-radius: 20px;
          padding: 8px 20px;
          font-size: 13px;
          text-transform: none;
          font-weight: 600;
          width: 100%;
          border: 1px solid #dadce0;
          transition: all 0.2s ease;
          margin: 0 !important;
        }

        .install-btn:hover {
          background-color: #e8eaed;
        }
      `
        ];
    }
    _getInitials() {
        if (this._person && this._person.exists() && this._person.data().name) {
            const parts = this._person.data().name.split(' ');
            return parts.map((p) => p[0]).join('').substring(0, 2).toUpperCase();
        }
        if (this._user && this._user.email) {
            return this._user.email.substring(0, 2).toUpperCase();
        }
        return '?';
    }
    render() {
        return html `
      <div>
        <button class="trigger-btn" @click=${() => { this.shadowRoot.getElementById("account").open(); }} title="Account">
          ${this._person && this._person.exists() && this._person.get("thumbnail_200") ? html `<img class="trigger-img" src="${this._person.get("thumbnail_200")}"/>` : accountCircle}
        </button>  

        <paper-dialog id="account">
          <header class="dialog-header">
            Account Profile
            <button class="close-btn" @click=${() => { this.shadowRoot.getElementById("account").close(); }} title="Close">${closeIcon}</button>
          </header>
          
          <div class="dialog-body">
            <div class="company-name">${this._company && this._company.exists() ? this._company.data().name : ''}</div> 
            
            <div class="profile-section">
              ${this._person && this._person.exists() && this._person.get("thumbnail_200") ?
            html `<img class="profileImage" src="${this._person.get("thumbnail_200")}"/>` :
            html `<div class="initials-avatar">${this._getInitials()}</div>`}
              <div class="user-name">${this._person && this._person.exists() ? this._person.data().name : ''}</div>
            </div>

            <div class="roles-section">
              ${this._person && this._person.exists() && this._person.data().roles && this._person.data().roles.length > 0 ? html `
                <div class="roles-title">Roles</div>
                <div class="roles-container">
                  ${this._person.data().roles.map((r) => html `<span class="role-tag">${r}</span>`)}
                </div>
              ` : html `
                <div class="no-roles">No Roles Assigned</div>
              `}
            </div>

            <div class="actions-section">
              <paper-button class="logout-btn" @click=${() => { this._signOut(); }} dialog-confirm>Log Out</paper-button>
              <paper-button class="reset-btn" @click=${() => { this._sendPasswordReset(); }} title="Send an email to your account to reset your password.">Password Reset</paper-button>
              
              <div class="install-prompt" id="install_div" style="display: none;">
                <paper-button class="install-btn" @click=${() => { this.installClick(); }} dialog-confirm>Install App</paper-button>
              </div>
            </div>  
          </div>
        </paper-dialog>
      </div>
    `;
    }
    async _signOut() {
        let auth = getAuth(window.firebase);
        try {
            await signOut(auth);
        }
        catch (err) {
            console.error("Error signing out from Firebase Auth:", err);
        }
        store.dispatch(firebaseSignOut());
        setTimeout(function () { location.reload(); }, 100);
    }
    _sendPasswordReset() {
        let auth = getAuth(window.firebase);
        let currentUser = auth.currentUser;
        if (confirm("Do you want to reset your password?") && currentUser && currentUser.email) {
            sendPasswordResetEmail(auth, currentUser.email).then(() => {
                alert("A password reset email has been sent. Logging you out...");
                this._signOut();
            }).catch((err) => {
                alert("Failed to send password reset email: " + err.message);
            });
        }
    }
    installClick() {
        if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            this.deferredPrompt.userChoice
                .then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                }
                else {
                    console.log('User dismissed the A2HS prompt');
                }
                this.deferredPrompt = null;
            });
            window.addEventListener('appinstalled', () => {
                console.log('a2hs installed');
            });
        }
    }
    constructor() {
        super();
        this._company = undefined;
        this._user = undefined;
        this._userProfileDoc = undefined;
        this._person = undefined;
        this.deferredPrompt = undefined;
        window.addEventListener('beforeinstallprompt', (e) => {
            console.log("beforeinstall prompt fired");
            e.preventDefault();
            this.deferredPrompt = e;
            var d = this.shadowRoot.getElementById("install_div");
            if (d) {
                d.style.display = '';
            }
        });
    }
    firstUpdated() {
        var state = store.getState();
        this._company = state.app.companyDoc;
        this.requestUpdate("_company");
        this._user = state.app.user;
        this.requestUpdate("_user");
        this._userProfileDoc = state.app.userDoc;
        this.requestUpdate("_userProfileDoc");
        this._person = state.app.personDoc;
        this.requestUpdate("_person");
    }
};
__decorate([
    property({ type: Object })
], MyAccount.prototype, "_company", void 0);
__decorate([
    property({ type: Object })
], MyAccount.prototype, "_user", void 0);
__decorate([
    property({ type: Object })
], MyAccount.prototype, "_userProfileDoc", void 0);
__decorate([
    property({ type: Object })
], MyAccount.prototype, "_person", void 0);
__decorate([
    property({ type: Object })
], MyAccount.prototype, "deferredPrompt", void 0);
MyAccount = __decorate([
    customElement('my-account')
], MyAccount);
export { MyAccount };
